import { render, staticRenderFns } from "./LoginRegisterMobile.vue?vue&type=template&id=1b474302"
import script from "./LoginRegisterMobile.vue?vue&type=script&lang=js"
export * from "./LoginRegisterMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports